import React from 'react';
import { View, colors, Heading, Icon, Button } from '@fairygodboss/ui';
import window from 'global/window';
import { GridColumnWrapper } from './GridColumnWrapper';
import { useEventRegistration } from '../EventRegistrationContext';
import {
    EVENT_OVER_WITH_VIDEO_BANNER,
    getFormattedDateString,
    getFormattedTimeString,
    REGISTER_NOW_BUTTON,
} from './helpers';
import { AuthWrapper } from '../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { VideoPlayButton } from './AboveTheFold';
import { AddToCalendarButton } from './AddToCalendarButton';

export const BottomRegistrationSection = () => {
    const {
        event,
        registrationButtonText,
        bannerText,
        onRegistrationButtonClick,
        isInternalEventUpcoming,
    } = useEventRegistration();
    const { eventType, title, startTime, endTime } = event;
    const startDateString = getFormattedDateString(startTime);
    const startTimeString = getFormattedTimeString(startTime);
    const endTimeString = getFormattedTimeString(endTime);

    return (
        <GridColumnWrapper
            backgroundColor={colors.info.light}
            gridAlignment="center"
            gridColumnSpacing={{ xs: 12, sm: 9, md: 8, lg: 8 }}
            px={{ _: '16px', sm: '0px', md: '24px', lg: '0px' }}
            py={{ _: '56px', sm: '48px' }}
        >
            <View
                color={colors.primary[60]}
                fontWeight="600"
                fontSize="16px"
                lineHeight="20px"
                letterSpacing="-0.4px"
                textAlign="center"
            >
                {eventType.toUpperCase()}
            </View>
            <Heading
                pt="16px"
                textAlign="center"
                variant={{ _: 'headingMd', md: 'headingXl' }}
            >
                {title}
            </Heading>
            <View
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection={{ _: 'column', sm: 'row' }}
                pt={{ _: '16px', sm: '18px' }}
            >
                <View display="flex" alignItems="center">
                    <View mr="12px" height="20px">
                        <Icon
                            variant="calendar_24"
                            display={{ _: 'none', sm: 'inherit' }}
                        />
                    </View>
                    <View as="span">{startDateString}</View>
                </View>
                <View
                    display="flex"
                    alignItems="center"
                    pt={{ _: '8px', sm: '0px' }}
                >
                    <View mr="12px" height="20px" ml="28px">
                        <Icon
                            variant="clock_24"
                            display={{ _: 'none', sm: 'inherit' }}
                        />
                    </View>
                    <View as="span">{`${startTimeString} - ${endTimeString} ET`}</View>
                </View>
            </View>
            {registrationButtonText ||
            isInternalEventUpcoming ||
            bannerText === EVENT_OVER_WITH_VIDEO_BANNER ? (
                <View
                    pt={{ _: '24px', sm: '34px' }}
                    display="flex"
                    justifyContent="center"
                >
                    {registrationButtonText ? (
                        <AuthWrapper
                            hash="RegisterEvent"
                            cookie={{ name: 'REGISTER_EVENT', value: true }}
                            component={
                                <Button
                                    onPress={onRegistrationButtonClick}
                                    size="large"
                                    variant="primary"
                                >
                                    {registrationButtonText ===
                                    REGISTER_NOW_BUTTON
                                        ? 'Register for event'
                                        : registrationButtonText}
                                </Button>
                            }
                            redirectUrl={window?.location?.pathname}
                            loginTrigger="register-event"
                        />
                    ) : null}
                    {isInternalEventUpcoming ? (
                        <AddToCalendarButton event={event} size="large" />
                    ) : null}
                    {bannerText === EVENT_OVER_WITH_VIDEO_BANNER ? (
                        <VideoPlayButton bottomView />
                    ) : null}
                </View>
            ) : null}
        </GridColumnWrapper>
    );
};

BottomRegistrationSection.displayName = 'BottomRegistrationSection';
